import React, { Component, Fragment } from 'react';
import { UtilityService } from "../../services";
// import { profilePic } from '../../assets/images/pro1.jpg';
//import { Grid, Image } from 'semantic-ui-react'
import FullCalendar from 'fullcalendar-reactwrapper';
import "../../../node_modules/fullcalendar-reactwrapper/dist/css/fullcalendar.min.css"
import AlertContainer from 'react-alert';
class AddNewCustomer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            events: [
                {
                    title: 'All Day Event',
                    start: '2018-07-01'
                },
                {
                    title: 'Long Event',
                    start: '2017-05-07',
                    end: '2017-05-10'
                },
                {
                    id: 999,
                    title: 'Repeating Event',
                    start: '2017-05-09T16:00:00'
                },
                {
                    id: 999,
                    title: 'Repeating Event',
                    start: '2017-05-16T16:00:00'
                },
                {
                    title: 'Conference',
                    start: '2017-05-11',
                    end: '2017-05-13'
                },
                {
                    title: 'Meeting',
                    start: '2017-05-12T10:30:00',
                    end: '2017-05-12T12:30:00'
                },
                {
                    title: 'Birthday Party',
                    start: '2017-05-13T07:00:00'
                },
                {
                    title: 'Click for Google',
                    url: 'http://google.com/',
                    start: '2017-05-28'
                }
            ],
        }
    }
    alertOptions = {
        offset: 65,
        position: 'top left',
        theme: 'dark',
        time: 1000,
        transition: 'scale'
    }
    componentDidMount() {
        this.enableMultiSelect()
    }

    enableMultiSelect() {
        // $(document).ready(function () {
        //     $('#range-slct').multiselect();
        // });
    }

    render() {
        return (
            <Fragment>
                <div class="right-section">
                    <div class="row nopadding">
                        <div class="col-md-12 nopadding">
                            <div class="panel calendarPanel">
                                <div id="example-component">
                                    <FullCalendar
                                        id="your-custom-ID"
                                        header={{
                                            left: 'prev,next today myCustomButton',
                                            center: 'title',
                                            right: 'month,basicWeek,basicDay'
                                        }}
                                        defaultDate={'2018-07-12'}
                                        navLinks={true} // can click day/week names to navigate views
                                        editable={true}
                                        eventLimit={true} // allow "more" link when too many events
                                        events={this.state.events}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </Fragment>
        );
    }
}

export default AddNewCustomer;

{/* <script>
    $(document).ready(function() {
        $('#calendar').fullCalendar({
            header: {
                left: 'prev,next today',
                center: 'title',
                right: 'month,agendaWeek,agendaDay'
            },
            defaultDate: '2017-08-22',
            navLinks: true, // can click day/week names to navigate views
            businessHours: true, // display business hours
            editable: true,
            events: [{
                title: 'MAKE NK TAPE',
                start: '2017-09-01T10:35:00',
                End: '2017-09-01T19:35:00',
                color: '#00BCD4'
            }
            ]
        });

    });
   </script> */}






// WEBPACK FOOTER //
// ./src/pages/calendar/page.js